// Mock data for PixelCraft Studio website

export const siteData = {
  brandName: "CréaPrestige",
  tagline: "Créateur de sites web sur mesure",
  hero: {
    title: "Un site web professionnel qui inspire confiance à vos clients",
    subtitle: "Chez Créaprestige, nous créons des sites modernes, rapides et performants conçus pour renforcer votre crédibilité, attirer de nouveaux clients et développer votre présence en ligne.",
    ctaText: "Demander un devis",
    image: "https://images.unsplash.com/photo-1549399905-5d1bad747576"
  },
  services: [
    {
      id: 1,
      name: "Site Vitrine",
      price: "890",
      inherit: null,
      features: ["Accueil", "Prestations", "À propos", "Contact"],
      featuresOr: false,
      note: "Hébergement et maintenance à partir de 34€/mois"
    },
    {
      id: 2,
      name: "Site Vitrine 100% Personnalisé",
      price: "1390",
      inherit: "Tout le pack 890€ +",
      features: ["Réalisations", "Avis clients", "FAQ", "Fiche Google"],
      featuresOr: false,
      note: "Hébergement et maintenance à partir de 34€/mois"
    },
    {
      id: 3,
      name: "Site avec Réservation",
      price: "à partir de 2790",
      inherit: "Tout le pack 1390€ +",
      features: ["Réservation en ligne", "Demande de devis automatisée"],
      featuresOr: true,
      note: "Hébergement et maintenance à partir de 34€/mois"
    }
  ],
  pricing: [
    {
      id: 1,
      name: "Essentiel",
      description: "L'essentiel pour maintenir votre site en ligne en toute sécurité",
      price: "34",
      monthly: "34",
      features: [
        "Maintenance",
        "Hébergement",
        "Sécurité"
      ],
      popular: false,
      badge: null
    },
    {
      id: 2,
      name: "Pro",
      description: "La meilleure valeur pour faire évoluer votre site régulièrement",
      price: "49",
      monthly: "49",
      features: [
        "Maintenance",
        "Hébergement",
        "Sécurité",
        "1 modification / trimestre *"
      ],
      popular: true,
      badge: "⭐ Meilleure valeur"
    },
    {
      id: 3,
      name: "Premium",
      description: "Support prioritaire et modifications rapides pour votre business",
      price: "89",
      monthly: "89",
      features: [
        "Maintenance",
        "Hébergement",
        "Sécurité",
        "Support prioritaire",
        "1 modification / mois *",
        "Réponse en moins de 72h"
      ],
      popular: false,
      badge: "🔥 Premium"
    }
  ],
  contact: {
    title: "Prêt à démarrer votre projet ?",
    subtitle: "Contactez-moi pour discuter de vos besoins et obtenir un devis personnalisé",
    email: "creaprestige.14@gmail.com",
    phone: "06 12 28 52 66"
  }
};
